import { Component, EventEmitter, inject, input, OnInit, Output, signal } from '@angular/core';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { SingleMenuItem } from '../../models/Customer Order model/single-menu-item.model';
import { CouponService } from '../../Services/coupon.service';
import { NotificationService } from '../../Services/notification.service';

@Component({
  selector: 'app-coupon-row',
  templateUrl: './coupon-row.component.html',
  styleUrl: './coupon-row.component.scss'
})
export class CouponRowComponent implements OnInit{
  Id = input.required<number>();
  ItemId = input.required<number>();
  Code = input.required<string>();
  isVisible = input<boolean>();

  newisVisible = signal<boolean>(true);

  menuItemService = inject(MenuItemsServiceService);
  couponService = inject(CouponService);
  notificationService = inject(NotificationService);
  menuItem!: SingleMenuItem;

  @Output() deleted = new EventEmitter();

  ngOnInit(): void {
      this.menuItemService.getMenuItem(this.ItemId()).subscribe({
        next: (response) => {
          this.menuItem = response;
        }
      })
  }

  onDelete(id: number) {
    this.couponService.deleteCoupon(id).subscribe({
      next: () => {
        this.deleted.emit();
        this.showSuccessDelete();
      },
      error: (err) =>{
        this.showErrorDelete();
      }
    })
  }

  onIconClick(id: number) {
    this.couponService.updateStatus(id).subscribe({
      next: (response) =>{
        this.newisVisible.set(!this.newisVisible()); // Toggle the value
        this.showSuccessUpdate();
      },
      error: (err) => {
        this.showErrorUpdate();
      }
    });
  
  }

  showErrorUpdate() {
    this.notificationService.showMessage('Failed To Update Coupon Status', 'danger');
  }
  showErrorDelete() {
    this.notificationService.showMessage('Failed To Update Coupon Status', 'danger');
  }

  showSuccessUpdate() {
    this.notificationService.showMessage(
      'Coupon Status Has Been updated Successfully',
      'success'
    );
  }
  showSuccessDelete() {
    this.notificationService.showMessage(
      'Coupon Has Been deleted Successfully',
      'success'
    );
  }


}
